import AttemptingConnectionMessage from "./ChatMessages/AttemptingConnectionMessage";
import NetworkErrorMessage from "./ChatMessages/NetworkErrorMessage";
import ProcessingMessage from "./ChatMessages/ProcessingMessage";
import StreamedMessage from "./ChatMessages/StreamedMessage";
import StreamedWithSource from "./ChatMessages/StreamedWithSource";
import ToolCallingMessage from "./ChatMessages/ToolCallingMessage";
import type { MessageType } from "./ChatMessages/types";

type ChatMessageContentProps = {
	type: MessageType;
};

const ChatMessageContent = ({ type }: ChatMessageContentProps) => {
	switch (type.type) {
		case "networkError":
			return (
				<NetworkErrorMessage
					networkErrorMessage={type.networkErrorMessage}
					onPressRetry={type.onPressRetry}
				/>
			);
		case "streamed":
			return <StreamedMessage text={type.text} />;
		case "streaming":
			return <StreamedMessage text={type.text} />;
		case "attemptingConnection":
			return <AttemptingConnectionMessage text={type.text} />;
		case "processing":
			return <ProcessingMessage />;
		case "toolCalling":
			return (
				<ToolCallingMessage
					toolCallingState={type.toolCallingState}
					text={type.text}
					toolCallingIcon={type.toolCallingIcon}
					content={type.content}
				/>
			);
		case "streamedWithSource":
			return (
				<StreamedWithSource
					sources={type.sources}
					onPressAllSources={type.onPressAllSources}
					onPressSource={type.onPressSource}
				/>
			);
		default:
			return null;
	}
};

export default ChatMessageContent;
